import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 107 109",
    fill: "none",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="m35.6 54.1 71.4-17V.1H70zM.2 53.5c0 4.4.5 8.7 1.6 12.8l33.8-12.2L1.5 41.8C.7 45.6.2 49.5.2 53.5M12.8 19l22.8 35.1L46.1.6C32.8 2.5 21.1 9.2 12.8 19m22.8 35.1 71.4 17v37.1H70zM12.8 89.2l22.8-35.1 10.5 53.5c-13.3-1.8-25-8.6-33.3-18.4" fill="#F30"/>' }
  })
);